import React from 'react';
import DeepMerge from "../utils/DeepMerge";

import { Menu as MUIMenu } from '@material-ui/core';

function Menu(props) {
	let merged = DeepMerge.merge({
		anchorOrigin: {
			vertical: 'bottom',
			horizontal: 'center'
		},
		transformOrigin: {
			vertical: 'top',
			horizontal: 'center'
		},
		getContentAnchorEl: null
	}, props);

	return (
		<MUIMenu {...merged}></MUIMenu>
	);
}

export default Menu;